import { getEnv } from "@umami/utils";
export { getEnv };

export const PRICING_API_URL = getEnv("VITE_PRICING_API_URL");

export const ETHEREUM_NETWORK_CONFIG = getEnv("VITE_ETHEREUM_NETWORK_CONFIG");

export const ETHERLINK_NETWORK_CONFIG = getEnv("VITE_ETHERLINK_NETWORK_CONFIG");

// Used to determine if we should show the staging password prompt
// This flag should be set to "true" in the staging environment
export const IS_STAGING = getEnv("VITE_IS_STAGING") === "true";
